export const getStatoCollezioneColor = (stato: string): "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" => {
    switch (stato) {
        case 'PROT':
            return 'info';
        case 'CAMP':
            return 'warning';
        case 'AN':
            return 'error';
        default:
            return 'default';
    }

};export const getStatoOdLColor = (stato: string): "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" => {
    switch (stato) {
        case 'CONF':
            return 'info';
        case 'ARR':
            return 'warning';
        case 'DONE':
            return 'success';
        case 'AN':
            return 'error';
        default:
            return 'default';
    }
};